<template>
  <div
    v-if="subject.journal"
    :class="['subject-item', {'subject-item-accepted': subject.journal.materials.length > 0}]"
    >
    <h4 class="head">
      <Button
        :type="workspace.onair ? 'error' : 'primary'""
        v-if="workspace && isWritable(workspace.channel_id) && subject.journal.materials.length == 0 && !subject.withdrawal"
        icon="md-add"
        size="small"
        class="submit"
        @click="setSubjectAcceptModalTarget(subject)"
        >
        採用する
      </Button>
      <div>
        <Icon v-if="subject.topic" :type="subject.topic | formatTopicIcon"></Icon>
        <span v-if="subject.topic">
          {{ subject.topic.name }}
        </span>
        <div :class="[{'warning': (current - subject.modified_at) <= 259200, 'critical': (current - subject.modified_at) > 259200}]" style="margin-right: 100px; padding: 0.15em;" v-if="(current - subject.modified_at) > 86400">
          <span style="font-weight: bold" v-if="(current - subject.modified_at) >= 259200"><p>※ 情報取得から72時間以上経過しています、内容を確認してください</p></span>
          <span style="font-weight: bold" v-else><p>※ 情報取得から24時間以上経過しています、内容を確認してください</p></span>
        </div>
      </div>
    </h4>
    <div class="text" :class="{withdrawal: subject.withdrawal}">
      {{ subject.journal.text }}
    </div>
    <Card v-if="subject.journal.meta.detail" style="margin: 10px 0; font-size: 0.9em">
      <h4 v-if="subject.journal.meta.detailTitle">{{ subject.journal.meta.detailTitle }}</h4>
      <template v-if="subject.journal.meta.detail.split('\n').length > 1">
        <p>{{ subject.journal.meta.detail.split("\n")[0] }}</p>
        <a
            style="display: inline-block; width: 100%; text-align: right"
            v-if="!contentDetailVisibility"
            @click="contentDetailVisibility = true"
        >
          続きを読む▼
        </a>
        <p
            v-if="contentDetailVisibility"
            v-for="i in subject.journal.meta.detail.split('\n').slice(1)"
        >
          {{ i }}
        </p>
        <a
            style="display: inline-block; width: 100%; text-align: right"
            v-if="contentDetailVisibility"
            @click="contentDetailVisibility = false"
        >
          隠す▲
        </a>
      </template>
      <template v-else>
        <p>{{ subject.journal.meta.detail }}</p>
      </template>
    </Card>
    <Card v-else-if="subject.journal.meta.email_content" style="margin: 10px 0; font-size: 0.9em">
      <template v-if="subject.journal.meta.email_content.split('\n').length > 1">
        <p>{{ subject.journal.meta.email_content.split("\n")[0] }}</p>
        <a
          style="display: inline-block; width: 100%; text-align: right"
          v-if="!emailContentVisibility"
          @click="emailContentVisibility = true"
        >
          続きを読む▼
        </a>
        <p
          v-if="emailContentVisibility"
          v-for="i in subject.journal.meta.email_content.split('\n').slice(1)"
        >
          {{ i }}
        </p>
        <a
          style="display: inline-block; width: 100%; text-align: right"
          v-if="emailContentVisibility"
          @click="emailContentVisibility = false"
        >
          隠す▲
        </a>
      </template>
      <template v-else>
        <p>{{ subject.journal.meta.email_content }}</p>
      </template>
    </Card>
    <div class="action">
      <span style="padding-right: 1.0em;">
        <Icon type="md-time"></Icon>
        {{ subject.modified_at | formatDate('MM-DD HH:mm') }}
        ({{ subject.modified_at | fromNow }})
      </span>
      <span
        v-if="subject.journal"
        style="padding-right: 1.0em;"
        >
        {{ subject.journal.text.length }}文字
        <template
          v-if="subject.journal.revisions.length > 1"
          >
          , 修正済み
        </template>
      </span>
      <span
        v-if="'ref' in subject.journal.meta"
        style="padding-right: 1.0em;"
        >
        <a
          :href="subject.journal.meta.ref"
          target="_blank">
          <Icon type="ios-undo"></Icon>
          <template v-if="subject.journal.meta.ref.includes('transit.yahoo.co.jp')">参考サイト</template>
          <template v-else>公式サイト</template>
        </a>
      </span>
      <span
        v-if="'email_sender' in subject.journal.meta"
        style="padding-right: 1.0em;"
        >
        <Icon type="ios-mail" />
        {{ subject.journal.meta.email_sender }}
      </span>
      <span
        style="padding-right: 1.0em;"
        v-if="isWritable(workspace.channel_id)"
        >
        <a @click="setJournalEditModalTarget(subject.journal)">
          <Icon type="md-create"></Icon>
          編集
        </a>
      </span>
      <span
        style="padding-right: 1.0em;"
        v-if="isWritable(workspace.channel_id) && subject.tags.includes('メール:*') && !subject.withdrawal"
        >
        <a @click="withdraw(subject.id)">
          <Icon type="md-remove-circle" />
          取消
        </a>
      </span>
      <span
        style="padding-right: 1.0em;"
        v-if="isWritable(workspace.channel_id) && subject.tags.includes('メール:*') && subject.withdrawal"
        >
        <a @click="unwithdraw(subject.id)">
          <Icon type="md-redo" />
          元に戻す
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { fromNow, formatDate } from '../../utils'

export default {
  props: ['subject'],
  data() {
    return {
      emailContentVisibility: false,
      contentDetailVisibility: false
    }
  },
  computed: {
    ...mapGetters([
      'isWritable',
      'getWorkspace',
    ]),
    workspace() {
      return this.getWorkspace(this.$route.params)
    },
    current() {
      return new Date().getTime() / 1000;
    }
  },
  methods: {
    ...mapActions({
      setJournalEditModalTarget: 'dashboard/setJournalEditModalTarget',
      setSubjectAcceptModalTarget: 'dashboard/setSubjectAcceptModalTarget',
    }),
    async withdraw(subjectId) {
      await this.$store.dispatch('withdrawSubject', {
        subjectId,
        ...this.$route.params
      })
    },
    async unwithdraw(subjectId) {
      await this.$store.dispatch('unwithdrawSubject', {
        subjectId,
        ...this.$route.params
      })
    }
  },
  filters: {
    fromNow,
    formatDate,
    formatTopicIcon: (topic) => {
      switch(topic.meta.category) {
        case 'railway':    return 'ios-train';
        case 'airway':     return 'ios-plane';
        case 'highway':    return 'md-car';
        case 'ferry':     return 'md-boat';
        case 'lifeline':   return 'ios-bulb';
        case 'typhoon':    return 'ios-rainy';
        case 'earthquake': return 'arrow-graph-down-right';
        case 'mudflow':    return 'ios-image';
        case 'weather':    return 'ios-umbrella';
        case 'flood':      return 'waterdrop';
        case 'breaking':   return 'logo-twitter';
        case 'evacuation':    return 'ios-alert-outline';
        case 'message':    return 'md-mail';
        case 'breaking':   return 'logo-twitter';
        default:           return 'ios-document';
      }
    },
  }
}
</script>

<style lang="less">
.subject-item {
  .message {
    .ivu-collapse-header {
      user-select: none;
      padding-left: 0px !important;
      i {
        margin-right: 4px !important;
      }

    }
    pre {
      padding: 7px;
    }
  }
  &.subject-item-accepted {
    .ivu-collapse-content {
      background-color: transparent;
      pre {
        background-color: #fff;
        border-radius: 3px;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.subject-item {
  padding: 20px 10px;
  border-bottom: 1px solid #dddee1;

  .head {
    color: #808695;
    font-size: 0.85em;
    padding-bottom: 5px;

    .submit {
      font-weight: bold;
      float: right;
    }
  }

  .text {
    font-size: 1.20em;
    font-weight: bold;
    white-space: pre-line;

    &.withdrawal {
      text-decoration: line-through;
    }
  }

  .note {
    background: #F1F1F1;
    border: 1px solid #E1E1E1;
    border-radius: 4px;
  }

  .action {
    padding-top: 5px;
    color: #80848f;
    font-size: 10px;
  }

  .warning {
    background-color: yellow;
  }

  .critical {
    background-color: red;
    color: white;
  }

  .message {
    font-size: 12px;
  }

  &.subject-item-accepted {
    background-color: #515a6e;
    a {
      color: #f8f8f9 !important;
    }
    .head {
      color: #c5c8ce;
    }
    .text {
      color: #ffffff;
    }
    .action {
      color: #f8f8f9;
    }
    .warning {
      color: #515A6E;
    }
    .message {
      i {
        color: #fff;
        font-weight: bold;
      }
      .title {
        color: #fff;
        font-weight: bold;
      }
    }
  }
}
</style>
